import {type RouteRecordRaw} from "vue-router";

export const BillingDetails: RouteRecordRaw = {
    path: '/billing/details/',
    name: 'billing-details',
    component: () => import('./billing-details.vue'),
};

export default [
    BillingDetails,
];
